import { IReadOptions, AjaxHelper } from '@samc/common';
import {
  flattenDomainLimitsTree,
  type IDomainLimitFolderDto,
  type ILimitPickerRow,
} from './DomainLimitsSource';
import { WorkflowQbTreeCachedSource } from './WorkflowQbTreeCachedSource';

export const WORKFLOW_TEMPLATE_DOMAIN_VALIDATION_DOMAIN_ID = '1';

/** Same folder/tree shape as DomainLimits; selectable leaves use `guid` like limits. */
export class ValidationTemplatesSource extends WorkflowQbTreeCachedSource<ILimitPickerRow> {
  private readonly _helper: AjaxHelper;

  public constructor(
    apiRoot: string | undefined,
    verificationToken: string | null,
    jwt: string | null,
    private readonly _domainId: string = WORKFLOW_TEMPLATE_DOMAIN_VALIDATION_DOMAIN_ID
  ) {
    super();
    this._helper = new AjaxHelper(apiRoot ?? '', verificationToken ?? null, null, jwt ?? null);
  }

  public async loadData(options: IReadOptions, abortController: AbortController): Promise<ILimitPickerRow[]> {
    const root = await this._helper.getData<IDomainLimitFolderDto | null>(
      '/api/ValidationTemplate/GetAll',
      { domainId: this._domainId, tree: 1 },
      { signal: abortController.signal }
    );
    if (!root) {
      return [];
    }
    const rows: ILimitPickerRow[] = [];
    flattenDomainLimitsTree(root, 0, rows, true);
    return rows;
  }
}
